module.exports = __webpack_public_path__ + "img/scan (13).7cb202a6.jpg";